<template>
  <v-card v-if="formDialog">
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('Customer Form') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="save">{{ $t('Save') }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-card-title>{{ $t('Create new customer') }}</v-card-title>
          <v-card-text>
            <v-text-field v-model="editItem.user.name" label="User name"></v-text-field>
            <v-text-field v-model="editItem.user.email" label="Email"></v-text-field>

            <v-text-field
              v-model="editItem.user.password"
              :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              :label="$t('Password')"
              @click:append="showPassword = !showPassword"
            ></v-text-field>

            <v-select
              v-model="role"
              :items="roles"
              attach="#imaginary-attachment"
              :label="$t('Roles')"
              multiple
            ></v-select>

            <v-autocomplete
              v-model="editItem.consultants"
              :items="consultants"
              :label="$t('Consultants')"
              multiple
              chips
              item-text="name"
              item-value="id"
              return-object
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selected.id"
                  close
                  class="chip--select-multi"
                  @input="remove(data.item.id)"
                >
                  <v-avatar>
                    <v-icon>mdi-account</v-icon>
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template slot="item" slot-scope="data">
                <template>
                  <v-list-tile-avatar>
                    <v-icon>mdi-account</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content :class="{ 'bg-inactive': data.item.trash }">
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    <v-list-tile-sub-title>
                      <template v-for="cat in data.item.categories">
                        {{ cat }}
                      </template>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-btn color="info" @click="close">{{ $t('go back') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import ProfileAPI from '@/services/api/profile.js';
import ConsultantAPI from '../../customers-and-consultants/services/consultantAPI';
export default {
  props: ['editItem', 'editIndex'],
  data() {
    return {
      formDialog: true,
      profile: 'customer',
      dateMenu: false,
      date: null,
      showPassword: false,
      consultants: [],
      role: [],
      roles: ['autonomous', 'pyme', 'employees', 'lopd'],
    };
  },

  mounted() {
    const userRoleNames = this.$store.getters.userRoleNames;

    if (userRoleNames.includes('superadmin')) {
      this.roles.push('superadmin');
    }

    this.role = this.editItem.roles;
    ConsultantAPI.getAllConsultants({ params: { active: 'true' } }).then(res => {
      this.consultants = [];
      console.log(res);
      res.data.data.forEach(element => {
        element.user.categories = element.categories;
        this.consultants.push(element.user);
      });
    });
  },
  methods: {
    close() {
      this.$emit('closeDialog', true);
    },
    save() {
      const consultantIds = [];
      if (this.editItem.consultants.length) {
        this.editItem.consultants.forEach(consultant => {
          consultantIds.push(consultant.id);
        });
      }
      let data = {
        user: {
          email: this.editItem.user.email,
          name: this.editItem.user.name,
          password: this.editItem.user.password,
          role: this.role,
        },

        consultants: consultantIds,
      };

      if (this.editItem.hasOwnProperty('id') && this.editItem.id) {
        ProfileAPI.updateProfile(this.profile, data, this.editItem.id).then(res => {
          this.$emit('profileSaved', {
            profile: res.data.data,
            index: this.editIndex,
          });
        });
      } else {
        ProfileAPI.postProfile(this.profile, data).then(res => {
          this.$emit('profileSaved', { profile: res.data.data, index: null });
        });
      }
    },
    remove(id) {
      this.$emit('removeConsultant', { id: id });
    },
  },
};
</script>

<style scoped>
.bg-inactive {
  background-color: pink;
}
</style>
